import { useDispatch } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from '@reduxjs/toolkit'
import { RootState } from 'src/store/store'

export const useAppDispatch = () => useDispatch<ThunkDispatch<RootState, undefined, AnyAction>>()
